import { isDataURI } from "./cleanImageSrc";

export async function copyMarkdownWithImages(markdownString: string) {
    // Regular expression to match markdown images
    const imageRegex = /!\[([^\]]*)\]\((data:image\/[^;]+;[^,]+,[^)]+)\)/g;

    // Array to store clipboard items
    let clipboardItems = [];

    // Parse the markdown string and convert images to blobs
    let lastIndex = 0;
    let match;

    while ((match = imageRegex.exec(markdownString)) !== null) {
        // Add text from the last index to the start of the image markdown
        if (match.index > lastIndex) {
            const text = markdownString.substring(lastIndex, match.index);
            clipboardItems.push(new ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }) }));
        }

        // Convert data URL to blob and add to clipboard items
        const dataURL = match[2];
        const blob = await (await fetch(dataURL)).blob();
        clipboardItems.push(new ClipboardItem({ [blob.type]: blob }));

        // Update the last index to after the current image markdown
        lastIndex = match.index + match[0].length;
    }

    // Add remaining text after the last image
    if (lastIndex < markdownString.length) {
        const text = markdownString.substring(lastIndex);
        clipboardItems.push(new ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }) }));
    }

    // Write to clipboard
    try {
        await navigator.clipboard.write(clipboardItems);
        console.log('Markdown with images copied to clipboard!');
    } catch (err) {
        console.error('Failed to copy to clipboard: ', err);
    }
}

export function getDataUris(htmlString: string){
    const parser = new DOMParser();
    const dataUri = []
    const doc = parser.parseFromString(htmlString, 'text/html');
    // Traverse and sanitize image elements
    const images = doc.querySelectorAll('img');
    for (let i = 0; i < images.length; i++) {
        const img = images[i];
        // Remove all attributes except src
        
        if (isDataURI(img.src)) dataUri.push(img.src)
    }
    return dataUri
}

export function getHTMLandTextWithImages(htmlString: string, hostedImages: string[]) {
    // Parse the HTML string into a document
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    // Traverse and sanitize image elements
    const images = doc.querySelectorAll('img');
    for (let i = 0; i < images.length; i++) {
        const img = images[i];
        // Remove all attributes except src
        const attributes = Array.from(img.attributes);
        for (let j = 0; j < attributes.length; j++) {
            const attr = attributes[j];
            if (attr.name !== 'src') {
                img.removeAttribute(attr.name);
            }
        }
        img.setAttribute("style", "width: 100%;") 
        // img.alt = "IMAGE HERE"
        img.src = hostedImages[i]
    }
    doc.querySelectorAll('p').forEach(p => {
        // Clean the attributes of the node
        // cleanAttributes(p);

        // Create a wrapper div and insert it before the paragraph
        const wrapper = doc.createElement('div');
        p.before(wrapper);
        p.setAttribute("style", "box-sizing: border-box; margin: 1.2em 0px;")
        // Move the paragraph inside the wrapper div
        wrapper.appendChild(p);
    });

    // Extract the sanitized HTML and copy it as a single ClipboardItem
    const sanitizedHTML = doc.body.innerHTML;
    let plainText = '';
    const processNode = (node: any) => {
        if (node.tagName && node.tagName.toLowerCase() === 'img') {
            // For each image, append its alt text
            plainText += '\n\n' + (node.alt || '') + '\n\n';
        } else {
            // For other nodes, get their text content
            if (node.tagName && node.tagName.toLowerCase() === 'div'){
                plainText += node.textContent || node.innerText || '';
            }
        }
        node.childNodes.forEach((x: any)=>processNode(x))
    }

    doc.body.childNodes.forEach(processNode)


    return {htmlOutput: sanitizedHTML, textOutput: plainText}

    
}

export const copyArticleToClipboard = async (html: string, text: string)=>{
    try {
        await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([html], { type: 'text/html' }),
                'text/plain' : new Blob([text], { type: 'text/plain' })
            })
        ]);
        console.log('Sanitized HTML with images copied to clipboard!');
    } catch (err) {
        console.error('Failed to copy to clipboard: ', err);
    }
}

// export async function copyHTMLWithImages(htmlString: string) {
//     // Parse the HTML string into a document
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(htmlString, 'text/html');
    
//     // Array to store clipboard items
//     let clipboardItems = [];

//     // Traverse and process images
//     const images = doc.querySelectorAll('img[src^="data:image/"]');
//     images.forEach(async (o_img: Element)=>{
//         console.log("IMAGE HERE", o_img)
//         let img = o_img as HTMLImageElement
//         // const dataURL = img.src;
//         // const blob = await (await fetch(dataURL)).blob();
//         // img.src = URL.createObjectURL(blob);
//         img.src = "https://d2yeqsyplprmo7.cloudfront.net/static/media/homehero.6346034235d1f6e3521f.png"
//     })
        
    
    
//     // Append the processed HTML as a ClipboardItem
//     const processedHTML = doc.body.innerHTML;
//     console.log("COPYING", processedHTML)

//     try {
//         await navigator.clipboard.write([
//             new ClipboardItem({
//                 'text/html': new Blob([processedHTML], { type: 'text/html' })
//             })
//         ]);
//         console.log('HTML with images copied to clipboard!');
//     } catch (err) {
//         console.error('Failed to copy to clipboard: ', err);
//     }
// }
